import React, { useEffect, useState } from "react";
import ScoreBoard from "../Component/ScoreBoard";
import Tabview from "../Component/Tabview";
import Ads from "./Ads";
import UserChoice from "./UserChoice";
import axios from "axios";

// ICONS
import { FaCirclePlay } from "react-icons/fa6";
import { ExclusiverlyVideoData, exclusiverlyVideoData } from "../Constants/exclusiverlyVideoData";
import { currentSeriesData } from "../Constants/currentSeriesData";
import { FaFacebook } from "react-icons/fa6";
import { MdOutlineArrowOutward } from "react-icons/md";
import { FaYoutube } from "react-icons/fa6";
import { TableRow, tableData } from "../Constants/tableData";
import { MatchNews, matchNewsData } from "../Constants/matchNewsData";
import RankTabView from "../Component/RankTabView";
import RankTable from "../Component/RankTable";
import SmallAd from "../Component/SmallAd";

interface NewsItem {
  id: number;
  title: string;
  slug: string;
  content: string;
  excerpt: string;
  status: string;
  image: string;
  info: Record<string, any>;
  ref_id: number;
  createdAt: string;
  updatedAt: string;
}


interface News {
  isLoading: boolean;
  isError: boolean;
  data: NewsItem[]; 
}


const NEWS_BASE_URL = 'https://api.dev.cricketgully.com/v1/news';

const Home = () => {
  const [showAllNews, setShowAllNews] = useState(false);
  const [showAllShortNews, setShowAllShortNews] = useState(false);
  const [newsData, setNewsData] = useState<News>({
    isLoading: false,
    isError: false,
    data: []
  });

  const newsItems = [1,2,3,4,5,6,7,8,9,10];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setNewsData(prevState => ({
          ...prevState,
          isLoading: true
        }));

        const response = await axios.get(NEWS_BASE_URL);
        console.log(response.data.data); 

        setNewsData(prevState => ({
          ...prevState,
          isLoading: false,
          data: response.data.data 
        }));

      } catch (error) {
        console.log('error', error);
        setNewsData(prevState => ({
          ...prevState,
          isLoading: false,
          isError: true
        }));
      }
    };

    fetchData();
  }, []);
  
  const removeHtmlTagsAndEntities = (html: string): string => {
    // Remove HTML tags
    const strippedHtml = html.replace(/<[^>]*>/g, '');
  
    // Decode HTML entities
    const element = document.createElement('textarea');
    element.innerHTML = strippedHtml;
    return element.value;
  };
  
  const renderNews = (): JSX.Element[] => {
    if (newsData.isLoading) {
      return [<p>Loading...</p>];
    }
  
    if (newsData.isError) {
      return [<p>Something went wrong. Please try again.</p>]
    }
  
    return newsData.data.map((item: NewsItem, index: number) => {
      return (
        <React.Fragment key={index}>
          <div className="border-b border-gray-300 my-4"></div>
          <div className="flex">
            <img src={item.image} alt="" className="h-20 min-w-32 mr-2 rounded-lg" />
            <div>
              <p className="font-semibold text-base/5">
                {/* {item.title} */}
                {removeHtmlTagsAndEntities(item.excerpt)}
              </p>
              <p className="text-gray-600 text-[12px] mt-1">
                {item.slug}
                <span className="text-gray-400 text-[10px] ml-3" >07-Oct-2023  •  11:36AM</span>
              </p>
            </div>
          </div>
        </React.Fragment>
      );
    });
  };

  const renderShortNews = (): JSX.Element[] => {
    return matchNewsData.map((item: MatchNews, index: number) => {
      return (
        <div className="mt-2 p-3" style={{ backgroundColor: '#F8F8F8' }} key={index}>
          <p className="text-sm">
            {item.title}
          </p>
          <p className="text-gray-400 text-xs mt-1">
            {item.dateTime}
          </p>
        </div>
      );
    });
  };

  return (
    <div className="container mx-auto max-w-screen-xl px-2 pt-3 pb-12">
      {/* TAB VIEW */}
        <div>
          <Tabview />
        </div>
        <div className="mt-5">
          <ScoreBoard />
        </div>
        <div className="my-3">
          <UserChoice />
        </div>
        <div className="my-5">
          <Ads />
        </div>
        <div>
          <div className="grid grid-cols-12 gap-4">
            <div className="lg:col-span-3 col-span-12">
              <div className="rounded-lg bg-white shadow p-4 text-white">
                <SmallAd />
              </div>
              <div className="rounded-lg bg-white shadow p-4 mt-4">
                <p className="text-lg font-semibold uppercase">
                  points Table
                </p>
                <form className="shadow-lg mt-2">
                  <select id="countries" className="bg-white border text-black text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option className="text-black" value="" disabled selected>IPL Points Table 2024</option>
                    <option className="text-black" value="US">IPL Points Table 2023</option>
                    <option className="text-black" value="CA">IPL Points Table 2022</option>
                    <option className="text-black" value="FR">IPL Points Table 2021</option>
                    <option className="text-black" value="DE">IPL Points Table 2022</option>
                  </select>
                </form>
                <div className="relative overflow-x-auto mt-3">
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase">
                      <tr>
                        <th scope="col" className="px-1 py-2">
                          Team
                        </th>
                        <th scope="col" className="px-1 py-2">
                          M
                        </th>
                        <th scope="col" className="px-1 py-2">
                          W
                        </th>
                        <th scope="col" className="px-1 py-2">
                          L
                        </th>
                        <th scope="col" className="px-1 py-2">
                          T
                        </th>
                        <th scope="col" className="px-1 py-2">
                          NR
                        </th>
                        <th scope="col" className="px-1 py-2">
                          PT
                        </th>
                        <th scope="col" className="px-1 py-2">
                          NRR
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        tableData.map((item:TableRow, index:number) => {
                          return(
                            <tr className="bg-white" key={index}>
                              <td className="px-1 py-4 text-black font-medium whitespace-nowrap">
                                {item.team}
                              </td>
                              <td className="px-1 py-4 text-black">
                                {item.matches}
                              </td>
                              <td className="px-1 py-4 text-black">
                                {item.wins}
                              </td>
                              <td className="px-1 py-4 text-black">
                                {item.losses}
                              </td>
                              <td className="px-1 py-4 text-black">
                                {item.ties}
                              </td>
                              <td className="px-1 py-4 text-black">
                                {item.noResults}
                              </td>
                              <td className="px-1 py-4 text-black">
                                {item.points}
                              </td>
                              <td className="px-1 py-4 text-black">
                                {item.netRunRate}
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>

              </div>
              <div className="rounded-lg bg-white shadow p-4 mt-4">
                <p className="text-lg font-semibold uppercase">
                  Latest News
                </p>
                {showAllShortNews ? renderShortNews() : renderShortNews().slice(0, 3)}
                <div className="flex justify-center">
                  {showAllShortNews ? (
                    <button onClick={() => setShowAllShortNews(false)} className="text-blue-500 hover:underline mt-2">
                      Show less
                    </button>
                  ) : (
                    newsItems.length > 3 && (
                      <button onClick={() => setShowAllShortNews(true)} className="text-blue-500 hover:underline mt-2 mr-2">
                        See more
                      </button>
                    )
                  )}
                </div>
              </div>
              <div className="rounded-lg bg-white shadow p-4 mt-4">
                <p className="uppercase text-lg font-semibold mb-2">Top Rankings</p>
                <div className="flex flex-wrap overflow-x-auto" style={{ scrollbarWidth: "none" }}>
                  <div className="flex rounded-xl border border-sky-500 p-0.5 bg-white tab_bar_wrappar ">
                    <div className="text-sm p-2 px-3 ml-0.2 my-0.2 tab_bar_selected_menu">
                      T20
                    </div>
                    <div className="text-sm p-2 mx-3 my-0.2">ODI</div>
                    <div className="text-sm p-2 mx-3 my-0.2">Test</div>
                  </div>
                </div>
                <div className="mt-3">
                  <RankTabView />
                </div>
                <div className="mt-2">
                  <RankTable />
                </div>
                <div className="mt-2">
                    <p className="text-gray-400 text-sm text-center">Latest Updated on 23 Mar 2024</p>
                </div>
              </div>
            </div>  
            <div className="lg:col-span-6 col-span-12">
              <div className="rounded-lg bg-white shadow p-4">
                <p className="capitalize font-semibold" >Top stories</p>
                <div className="border-b border-gray-300 my-4"></div>
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-12">
                    <img src="/static/topStories/1.png" alt="top_Stories_image_1" className="rounded-lg" />
                    <p className="font-semibold text-base mt-2">
                      World Cup 2023 Bangladesh vs Afghanistan 3rd Match PREDICTION, Playing 11, Pitch Report, Key Players
                    </p>
                    <p className="text-gray-400 mt-2 text-xs">
                      07-Oct-2023  •  11:36AM
                    </p>
                  </div>

                  <div className="lg:col-span-6 md:col-span-6 col-span-12 rounded-lg">
                    <img src="/static/topStories/2.png" alt="top_Stories_image_1" className="rounded-lg" style={{ height: '180px', width: '100%' }} />
                    <p className="font-semibold text-base mt-2">
                      Cummins ready for first taste of T20 captaincy
                    </p>
                    <p className="text-gray-400 mt-8 text-xs">
                      07-Oct-2023  •  11:36AM
                    </p>
                  </div>
                  <div className="lg:col-span-6 md:col-span-6 col-span-12 rounded-lg">
                    <img src="/static/topStories/3.png" alt="top_Stories_image_1" className="rounded-lg" style={{ height: '180px',width: '100%' }} />
                    <p className="font-semibold text-base mt-2">
                      IPL 2024 CKS vs RCB 1st Match PREDICTION, Playing 11, Pitch Report, Key Players
                    </p>
                    <p className="text-gray-400 mt-2 text-xs">
                      08-Oct-2023  •  01:36PM
                    </p>
                  </div>
                </div>
                

              </div>
              <div className="rounded-lg bg-white shadow p-4 mt-4">
                <img src="/static/topStories/4.png" alt="top_Stories_image_1" className="rounded-lg" />
                <p className="font-semibold text-base mt-2">
                  World Cup 2023 Bangladesh vs Afghanistan 3rd Match PREDICTION, Playing 11, Pitch Report, Key Players
                </p>
                <p className="text-gray-400 mt-2 text-xs">
                  07-Oct-2023  •  11:36AM
                </p>
              </div>

              <div className="rounded-lg bg-white shadow p-4 mt-4">
                <img src="/static/topStories/5.png" alt="top_Stories_image_1" className="rounded-lg" />
                <p className="font-semibold text-base mt-2">
                  World Cup 2023 Bangladesh vs Afghanistan 3rd Match PREDICTION, Playing 11, Pitch Report, Key Players
                </p>
                <p className="text-gray-400 mt-2 text-xs">
                  07-Oct-2023  •  11:36AM
                </p>
              </div>

              <div className="rounded-lg bg-white shadow p-4 mt-4">
                <img src="/static/topStories/6.png" alt="top_Stories_image_1" className="rounded-lg" />
                <p className="font-semibold text-base mt-2">
                  World Cup 2023 Bangladesh vs Afghanistan 3rd Match PREDICTION, Playing 11, Pitch Report, Key Players
                </p>
                <p className="text-gray-400 mt-2 text-xs">
                  07-Oct-2023  •  11:36AM
                </p>
              </div>


              <div className="rounded-lg shadow bg-white p-4 mt-4">
                <p className="font-semibold font-lg">Cricket News</p>
                {showAllNews ? renderNews() : renderNews().slice(0, 3)}
                <div className="flex justify-center">
                  {showAllNews ? (
                    <button onClick={() => setShowAllNews(false)} className="text-blue-500 hover:underline mt-2">
                      Show less
                    </button>
                  ) : (
                    newsItems.length > 3 && (
                      <button onClick={() => setShowAllNews(true)} className="text-blue-500 hover:underline mt-2 mr-2">
                        See more
                      </button>
                    )
                  )}
                </div>
              </div>


            </div>
            <div className="lg:col-span-3 col-span-12">
              <div className="rounded-lg bg-white shadow p-4 text-white">
                <SmallAd />
              </div>
              <div className="rounded-lg bg-white shadow px-4 py-5 mt-4">
                <p className="font-xl font-semibold capitalize mb-4">Exclusively Videos</p>
                {
                  exclusiverlyVideoData.map((item:ExclusiverlyVideoData, index:number) => {
                    return(
                      <div key={index} className="mt-6">
                        <div className="exclusively_videos rounded-lg flex justify-center items-center" style={{ backgroundImage: `url(${item.img})` }}>
                          <div className="overlay"></div>
                          <FaCirclePlay className="play-icon" />
                        </div>
                        <p className="font-semibold text-base/4 mt-2">
                          {item.title}
                        </p>
                      </div>
                    )
                  })
                }
              
              </div>

              <div className="rounded-lg bg-white shadow px-4 py-5 mt-4">
                <p className="font-xl font-semibold capitalize mb-4">current series </p>
                {
                  currentSeriesData.map((item:string) => {
                    return(
                      <div className="mt-2 p-3 rounded-lg current_Series_item">
                        {item}
                      </div>
                    )
                  })
                }
              </div>

              <div className="rounded-lg bg-white shadow px-4 py-5 mt-4">
                <p className="font-xl font-semibold capitalize mb-4">Follow Us</p>
                <div className="flex mt-2 justify-between items-center">
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="rounded-full" width="18" height="18" viewBox="0 0 102 102" id="instagram"><defs><radialGradient id="a" cx="6.601" cy="99.766" r="129.502" gradientUnits="userSpaceOnUse"><stop offset=".09" stop-color="#fa8f21"></stop><stop offset=".78" stop-color="#d82d7e"></stop></radialGradient><radialGradient id="b" cx="70.652" cy="96.49" r="113.963" gradientUnits="userSpaceOnUse"><stop offset=".64" stop-color="#8c3aaa" stop-opacity="0"></stop><stop offset="1" stop-color="#8c3aaa"></stop></radialGradient></defs><path fill="url(#a)" d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361" data-name="Path 16"></path><path fill="url(#b)" d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361" data-name="Path 17"></path><path fill="#fff" d="M461.114,477.413a12.631,12.631,0,1,1,12.629,12.632,12.631,12.631,0,0,1-12.629-12.632m-6.829,0a19.458,19.458,0,1,0,19.458-19.458,19.457,19.457,0,0,0-19.458,19.458m35.139-20.229a4.547,4.547,0,1,0,4.549-4.545h0a4.549,4.549,0,0,0-4.547,4.545m-30.99,51.074a20.943,20.943,0,0,1-7.037-1.3,12.547,12.547,0,0,1-7.193-7.19,20.923,20.923,0,0,1-1.3-7.037c-.184-3.994-.22-5.194-.22-15.313s.04-11.316.22-15.314a21.082,21.082,0,0,1,1.3-7.037,12.54,12.54,0,0,1,7.193-7.193,20.924,20.924,0,0,1,7.037-1.3c3.994-.184,5.194-.22,15.309-.22s11.316.039,15.314.221a21.082,21.082,0,0,1,7.037,1.3,12.541,12.541,0,0,1,7.193,7.193,20.926,20.926,0,0,1,1.3,7.037c.184,4,.22,5.194.22,15.314s-.037,11.316-.22,15.314a21.023,21.023,0,0,1-1.3,7.037,12.547,12.547,0,0,1-7.193,7.19,20.925,20.925,0,0,1-7.037,1.3c-3.994.184-5.194.22-15.314.22s-11.316-.037-15.309-.22m-.314-68.509a27.786,27.786,0,0,0-9.2,1.76,19.373,19.373,0,0,0-11.083,11.083,27.794,27.794,0,0,0-1.76,9.2c-.187,4.04-.229,5.332-.229,15.623s.043,11.582.229,15.623a27.793,27.793,0,0,0,1.76,9.2,19.374,19.374,0,0,0,11.083,11.083,27.813,27.813,0,0,0,9.2,1.76c4.042.184,5.332.229,15.623.229s11.582-.043,15.623-.229a27.8,27.8,0,0,0,9.2-1.76,19.374,19.374,0,0,0,11.083-11.083,27.716,27.716,0,0,0,1.76-9.2c.184-4.043.226-5.332.226-15.623s-.043-11.582-.226-15.623a27.786,27.786,0,0,0-1.76-9.2,19.379,19.379,0,0,0-11.08-11.083,27.748,27.748,0,0,0-9.2-1.76c-4.041-.185-5.332-.229-15.621-.229s-11.583.043-15.626.229" data-name="Path 18" transform="translate(-422.637 -426.196)"></path></svg>
                    <p className="text-base ml-2">Instagram</p>
                  </div>
                  <div>
                    <MdOutlineArrowOutward className="font-black text-xl" />
                  </div>
                </div>
                <div className="flex mt-2 justify-between items-center">
                  <div className="flex items-center">
                    <FaFacebook color="#1877F2" fontSize='large' />
                    <p className="text-base ml-2">Facebook</p>
                  </div>
                  <div>
                    <MdOutlineArrowOutward className="text-gray-400 text-xl" />
                  </div>
                </div>
                <div className="flex mt-2 justify-between items-center">
                  <div className="flex items-center">
                    <FaYoutube color="#FE0000" fontSize='large' />
                    <p className="text-base ml-2">Youtube</p>
                  </div>
                  <div>
                    <MdOutlineArrowOutward className="text-gray-400 text-xl" />
                  </div>
                </div>
                <div className="flex mt-2 justify-between items-center">
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="rounded-full" width="18" height="18" fill="none" viewBox="0 0 512 512" id="twitter"><g clip-path="url(#clip0_84_15697)"><rect width="512" height="512" fill="#000" rx="60"></rect><path fill="#fff" d="M355.904 100H408.832L293.2 232.16L429.232 412H322.72L239.296 302.928L143.84 412H90.8805L214.56 270.64L84.0645 100H193.28L268.688 199.696L355.904 100ZM337.328 380.32H366.656L177.344 130.016H145.872L337.328 380.32Z"></path></g><defs><clipPath id="clip0_84_15697"><rect width="512" height="512" fill="#fff"></rect></clipPath></defs></svg>
                    <p className="text-base ml-2">X <span className="text-gray-400" >{"(Twitter)"}</span></p>
                  </div>
                  <div>
                    <MdOutlineArrowOutward className="text-gray-400 text-xl" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default Home;
